<!-- Generated by scripts/generate-svg-components.mjs. Do not edit manually. -->
@switch (name) {
  @case ('arrow-down') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="11.2929" y1="17.2929" x2="17.2929" y2="11.2929" stroke="currentColor" stroke-width="2"/>
    <line x1="6.71363" y1="11.2995" x2="12.6034" y2="17.2995" stroke="currentColor" stroke-width="2"/>
    <line x1="12" y1="6" x2="12" y2="16" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('arrow-left') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="6.70711" y1="11.2929" x2="12.7071" y2="17.2929" stroke="currentColor" stroke-width="2"/>
    <line x1="12.7005" y1="6.71363" x2="6.70052" y2="12.6034" stroke="currentColor" stroke-width="2"/>
    <line x1="18" y1="12" x2="8" y2="12" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('arrow-right') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="17.2929" y1="12.7071" x2="11.2929" y2="6.70711" stroke="currentColor" stroke-width="2"/>
    <line x1="11.2995" y1="17.2864" x2="17.2995" y2="11.3966" stroke="currentColor" stroke-width="2"/>
    <line x1="6" y1="12" x2="16" y2="12" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('arrow-up') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12.7071" y1="6.70711" x2="6.70711" y2="12.7071" stroke="currentColor" stroke-width="2"/>
    <line x1="17.2864" y1="12.7005" x2="11.3966" y2="6.70052" stroke="currentColor" stroke-width="2"/>
    <line x1="12" y1="18" x2="12" y2="8" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('checkmark') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="5.70711" y1="11.2929" x2="9.70711" y2="15.2929" stroke="currentColor" stroke-width="2"/>
    <line x1="9.29289" y1="16.2929" x2="19.2929" y2="6.29289" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('chevron-down') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="11.2929" y1="15.2929" x2="17.2929" y2="9.29289" stroke="currentColor" stroke-width="2"/>
    <line x1="6.71363" y1="9.29948" x2="12.6034" y2="15.2995" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('chevron-left') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="8.70711" y1="11.2929" x2="14.7071" y2="17.2929" stroke="currentColor" stroke-width="2"/>
    <line x1="14.7005" y1="6.71363" x2="8.70052" y2="12.6034" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('chevron-right') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="15.2929" y1="12.7071" x2="9.29289" y2="6.70711" stroke="currentColor" stroke-width="2"/>
    <line x1="9.29948" y1="17.2864" x2="15.2995" y2="11.3966" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('chevron-up') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12.7071" y1="8.70711" x2="6.70711" y2="14.7071" stroke="currentColor" stroke-width="2"/>
    <line x1="17.2864" y1="14.7005" x2="11.3966" y2="8.70052" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('cross') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="6.94975" y1="6.94969" x2="16.8492" y2="16.8492" stroke="currentColor" stroke-width="2"/>
    <line x1="16.8582" y1="6.96006" x2="6.94903" y2="16.8499" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('error') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15ZM11 13H13V7H11V13Z" fill="currentColor"/>
    </svg>
  }
  @case ('filter') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="3" y1="8" x2="7" y2="8" stroke="currentColor" stroke-width="2"/>
    <line x1="3" y1="17" x2="12" y2="17" stroke="currentColor" stroke-width="2"/>
    <line x1="18" y1="17" x2="21" y2="17" stroke="currentColor" stroke-width="2"/>
    <line x1="13" y1="8" x2="21" y2="8" stroke="currentColor" stroke-width="2"/>
    <path d="M15 13C17.2091 13 19 14.7909 19 17C19 19.2091 17.2091 21 15 21C12.7909 21 11 19.2091 11 17C11 14.7909 12.7909 13 15 13ZM15 15C13.8954 15 13 15.8954 13 17C13 18.1046 13.8954 19 15 19C16.1046 19 17 18.1046 17 17C17 15.8954 16.1046 15 15 15Z" fill="currentColor"/>
    <path d="M10 4C12.2091 4 14 5.79086 14 8C14 10.2091 12.2091 12 10 12C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4ZM10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6Z" fill="currentColor"/>
    </svg>
  }
  @case ('location-off') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 12.5C12.4125 12.5 12.7656 12.3531 13.0594 12.0594C13.3531 11.7656 13.5 11.4125 13.5 11C13.5 10.5875 13.3531 10.2344 13.0594 9.94063C12.7656 9.64687 12.4125 9.5 12 9.5C11.5875 9.5 11.2344 9.64687 10.9406 9.94063C10.6469 10.2344 10.5 10.5875 10.5 11C10.5 11.4125 10.6469 11.7656 10.9406 12.0594C11.2344 12.3531 11.5875 12.5 12 12.5ZM12 18.0125C13.525 16.6125 14.6562 15.3406 15.3938 14.1969C16.1313 13.0531 16.5 12.0375 16.5 11.15C16.5 9.7875 16.0656 8.67188 15.1969 7.80312C14.3281 6.93438 13.2625 6.5 12 6.5C10.7375 6.5 9.67188 6.93438 8.80312 7.80312C7.93438 8.67188 7.5 9.7875 7.5 11.15C7.5 12.0375 7.86875 13.0531 8.60625 14.1969C9.34375 15.3406 10.475 16.6125 12 18.0125ZM12 20C9.9875 18.2875 8.48438 16.6969 7.49063 15.2281C6.49688 13.7594 6 12.4 6 11.15C6 9.275 6.60312 7.78125 7.80938 6.66875C9.01563 5.55625 10.4125 5 12 5C13.5875 5 14.9844 5.55625 16.1906 6.66875C17.3969 7.78125 18 9.275 18 11.15C18 12.4 17.5031 13.7594 16.5094 15.2281C15.5156 16.6969 14.0125 18.2875 12 20Z" fill="currentColor"/>
    </svg>
  }
  @case ('location-on') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 12.5C12.4125 12.5 12.7656 12.3531 13.0594 12.0594C13.3531 11.7656 13.5 11.4125 13.5 11C13.5 10.5875 13.3531 10.2344 13.0594 9.94063C12.7656 9.64687 12.4125 9.5 12 9.5C11.5875 9.5 11.2344 9.64687 10.9406 9.94063C10.6469 10.2344 10.5 10.5875 10.5 11C10.5 11.4125 10.6469 11.7656 10.9406 12.0594C11.2344 12.3531 11.5875 12.5 12 12.5ZM12 20C9.9875 18.2875 8.48438 16.6969 7.49063 15.2281C6.49688 13.7594 6 12.4 6 11.15C6 9.275 6.60312 7.78125 7.80938 6.66875C9.01563 5.55625 10.4125 5 12 5C13.5875 5 14.9844 5.55625 16.1906 6.66875C17.3969 7.78125 18 9.275 18 11.15C18 12.4 17.5031 13.7594 16.5094 15.2281C15.5156 16.6969 14.0125 18.2875 12 20Z" fill="currentColor"/>
    </svg>
  }
  @case ('message') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="1" stroke="currentColor" stroke-width="2"/>
    <path d="M3 6L12 12L21 6" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('plus') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
    <line x1="18.999" y1="12.0137" x2="4.99903" y2="12" stroke="currentColor" stroke-width="2"/>
    </svg>
  }
  @case ('success') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM11 12.1719L9.41406 10.5859L8 12L11 15L16 10L14.5859 8.58594L11 12.1719Z" fill="currentColor"/>
    </svg>
  }
  @case ('support') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="2"/>
    <rect x="11" y="7" width="2" height="6" fill="currentColor"/>
    <circle cx="12" cy="16" r="1" fill="currentColor"/>
    </svg>
  }
  @case ('user') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="3" stroke="currentColor" stroke-width="2"/>
    <line x1="5" y1="20" x2="19" y2="20" stroke="currentColor" stroke-width="2"/>
    <path d="M12 13C16.4183 13 20 16.5817 20 21H18C18 17.6863 15.3137 15 12 15C8.68629 15 6 17.6863 6 21H4C4 16.5817 7.58172 13 12 13Z" fill="currentColor"/>
    </svg>
  }
  @case ('warning') {
    <svg
          class="fdk-icon__svg"
          [attr.aria-hidden]="ariaHidden"
          [attr.aria-label]="normalizedAriaLabel"
          [attr.role]="role"
          focusable="false"
          [style.width]="resolvedSize"
          [style.height]="resolvedSize"
          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM11 16H13V10H11V16ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7Z" fill="currentColor"/>
    </svg>
  }
}
